import { apiClient } from "../api/ApiClient";
import { CreateCrudService } from "./CrudServiceFactory";
import type { Banner } from "../models/Banner";
import { BuildFormData } from "../utils/Util";
import { DataState } from "../models/DataState";

export function BannerService() {
  // Backend controller route.
  const Route = "banner";

  // true:  banner/GetAll/0/10
  // false: banner/GetAll?skip=0&limit=10
  const PaginationInPath = true;

  return CreateCrudService<Banner>({
    Route,
    PaginationInPath,
    EntityName: "Banner",
    PartialFields: ["Code", "Name"],
    LoadingMessage: "Loading banners...",
    SavingMessage: "Saving banner...",

    SaveRequest: async (data) => {
      const formData = BuildFormData(
        {
          banner: (data as Banner[]).map((banner) => ({
            ...banner,
            Code: banner.DataState === DataState.New ? "" : (banner.Code ?? ""),
          })),
        },
        { MaximumFieldCount: 1000 },
      );

      const response = await apiClient.post<Banner[]>(
        `${Route}/SaveBanner`,
        formData,
        { busyMessage: "Saving banner..." },
      );

      return response.data;
    },
  });
}
